import { IClientAccounts } from '../../models/client-accounts.interface';

export interface DecedentInfoState {
  firstName: string;
  middleName: string;
  lastName: string;
  decedentId_private: string;
  zipCode: string;
  addressLine1?: string;
  city?: string;
  state?: string;
  dateOfDeath: string;
  dateOfBirth: string;
  decedentPoid: string;
  isDeathVerified: boolean;
  deathStatusSetBy: string;
  multiplePoids: boolean;
  isReviewModalVisible: boolean;
  decedentIdExceededAttempts: boolean;
  inheritanceWaiverState: string;
  clearDateOfDeath?: string;
  decedentValidationValid?: boolean | null;
  decedentAccounts?: IClientAccounts | null;
  isAdvisedClientModalShown?: boolean;
}
